import type { IconStrategy } from '../types';
import { IconName } from '../types';

export class IncomingCompleted implements IconStrategy {
  get(): null | IconName {
    return IconName.IncomingCompleted;
  }
}
